import { render, staticRenderFns } from "./Care.vue?vue&type=template&id=88a94af8&scoped=true&"
import script from "./Care.vue?vue&type=script&lang=js&"
export * from "./Care.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88a94af8",
  null
  
)

export default component.exports